export default {
  last24hours: "Last 24 hours",
  today: "Today",
  yesterday: "Yesterday",
  lastThreeDays: "Last 3 Days",
  lastSevenDays: "Last 7 Days",
  complaintStats: "Complaint Stats",
  tagStats: "Tag Stats",
  conversationStats: "24-hour session statistics",
  kfStat: "Customer service monitoring",
  vipStat: "Vip conversation statistics",
  ratingStatistics: "Rating Stats",
  closedConversations: "Closed",
  openConversations: "Open Issues",
  closedIssues: "Closed Issues",
  ratingCount: "Number of Ratings",
  averageScore: "Average Score",
  serviceStatus: "Service Status",
  unclosedConversations: "Unclosed Conversations",
  unreadConversations: "Unread Conversations",
  conversationStatistics24h: "24h Conversation Statistics",
};
